/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SurveyQuestionType {
    SINGLE_SELECT = 'SingleSelect',
    MULTI_SELECT = 'MultiSelect',
}
